import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DataRefreshRendererComponent } from './data-refresh-renderer.component';

/**
 * Shared module for DataRefreshRendererComponent used by AppComponent and DataRefreshModule.
 */
@NgModule({
  declarations: [DataRefreshRendererComponent],
  imports: [CommonModule],
  exports: [DataRefreshRendererComponent],
})
export class DataRefreshRendererSharedModule {}
